import routes from 'app/zap-details/routes';

export default {
  routes,
};
